import { ReactNode } from "react";
import { useAuth } from "../../context/AuthContext";
import classes from "./DietitianTopbar.module.scss";

interface Props {
  title:    string;
  subtitle?: string;
  actions?: ReactNode;
}

const initials = (name: string) =>
  name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase();

const DietitianTopbar = ({ title, subtitle, actions }: Props) => {
  const { user } = useAuth();
  return (
    <header className={classes.topbar}>
      <div className={classes.topbar_left}>
        <h1 className={classes.title}>{title}</h1>
        {subtitle && <p className={classes.sub}>{subtitle}</p>}
      </div>
      <div className={classes.topbar_right}>
        {actions}
        <div className={classes.avatar}>
          {user?.name ? initials(user.name) : "TK"}
        </div>
      </div>
    </header>
  );
};

export default DietitianTopbar;
